// removed by extract-text-webpack-plugin
module.exports = {"header_container":"header_container","header_container_isWelcome":"header_container_isWelcome","header_row":"header_row","header_logo":"header_logo","header_logo_row":"header_logo_row","header_link_block":"header_link_block"};


//////////////////
// WEBPACK FOOTER
// ./src/view/screens/Header/style.scss
// module id = 1314
// module chunks = 0